import {Injectable, isDevMode} from '@angular/core';
import { ActivatedRouteSnapshot, RouterStateSnapshot, UrlTree, Router } from '@angular/router';
import {Observable} from 'rxjs';
import {EquipementService} from "../services/equipement.service";
import {UserService} from '../services/user.service';
import {LogementService} from "../services/logement.service";
import {map} from "rxjs/operators";
import {CarnetEquipement} from '../models/carnetEquipement';

@Injectable({
  providedIn: 'root'
})
export class EquipementEdition  {

  constructor(
    private userService: UserService,
    private equipementService: EquipementService,
    private logementService: LogementService,
    private router: Router
  ) {
  }

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
    const idLogement = this.logementService.getLogementCourantId();
    const idEquipement = parseInt(route.paramMap.get('id'));
    let carnetEquipement = null;

    const carnetEquipement$ = this.equipementService.findById(idLogement, idEquipement);

    carnetEquipement$.subscribe(ce => carnetEquipement = ce);

    return this.equipementService.isAuthorizedToEdit(carnetEquipement)
      ? true
      : this.router.navigate(['/accueil']);
  }
}
